import React from 'react'
import EcommerceDashboardContainer from '../../../Components/Dashboard/EcommerceDashboard'

export default function EcommerceDashboard() {
    return (
        <div className='page-body'>
            <EcommerceDashboardContainer />
        </div>
    )
}